let config;
if (process.env.NODE_ENV == 'production' && location.href.indexOf('.lan') === -1 && location.href.indexOf('192.168') === -1 && location.href.indexOf('localhost') === -1) { //正式机
    config = {
        API_BASE_URL: '/uc/', //API接口地址配置    /apis/ 直客 //http://ibapi.jf24k.lan 测试
        BASE_IMG_URL: 'https://media.bfgolds.com/', //图片服务器地址配置
        BASE_ACCOUNT_URL: 'https://muc.jf24k.hk/#/realAccount', //开户站点链接配置
        ANT_BASE_URL: 'https://third.antswallets.com/', //快捷支付PC版连接配置
        ServerIP: '[HKLive]47.52.210.28',
        logUrl: 'https://nxcollect.hflbysm.com/bin-log',
        BASE_LOGIN_URL: 'https://muc.jf24k.hk/login/',
        FRIEND_LINK: 'https://maccount.etb24k.com/register/firendopen.html',
        BASE_LIVE800_URL: 'https://www.jf24k.hk/common/live800.html',
        BASE_IMG_URL_ANTSWALLETS: "https://uapi.antswallets.com/", //蚂蚁钱包图片服务器地址
        BASE_IMG_URL_GOLDJUMP: 'https://jftun2ant.nbtwcw.com:50000'
    }
} else {
    config = {
        API_BASE_URL: '/uc/', //接口地址'http://192.168.0.202:8080/  /uc/
        BASE_IMG_URL: 'http://192.168.0.12', //图片服务器地址
        ANT_BASE_URL: 'http://192.168.0.247:8078', //快捷支付地址
        BASE_ACCOUNT_URL: 'http://muc.jf24k.lan/#/realAccount',
        ServerIP: '[Test]',
        logUrl: 'https://nxcollect.hflbysm.com/bin-log',
        BASE_LOGIN_URL: 'http://muc.jf24k.lan/login/',
        FRIEND_LINK: 'http://maccount.jf24k.lan/register/firendopen.html',
        BASE_LIVE800_URL: 'https://www.jf24k.hk/common/live800.html',
        BASE_IMG_URL_ANTSWALLETS: "http://192.168.0.247:8817/", //蚂蚁钱包图片服务器地址
        BASE_IMG_URL_GOLDJUMP: 'http://upay.antswallets.lan/'
    };
}
export default config


// WEBPACK FOOTER //
// ./src/axios/config.js